function reloadMiniCartAjax(){
  const cartDrawer = $('.cart-drawer');
  const miniCartBodyContainer = $('.js-cart-drawer-container');
  
  // Rerender mini cart
  cartDrawer.addClass('expanded loading-icon');
  
  jQuery.get(window.Shopify.routes.root + 'cart')
    .done(function(res){
      const $res = $($.parseHTML(res));
      const output = $res.find(".js-cart-drawer-ajax").html();
      const itemCountHtml = $res.find(".js-cart-drawer-item-count-ajax").html();
      miniCartBodyContainer.html(output);
      if (itemCountHtml) {
        cartDrawer.find(".cart-drawer__item-count").replaceWith(itemCountHtml);
      }
      cartDrawer.removeClass('loading-icon');
    })

  // Update free shipping prodgress bar
  jQuery.get(window.Shopify.routes.root + 'cart.js')
    .done(function(res){
      const data = JSON.parse(res);
      const freeShippingThreshold = 100
      const subtotal = data.items_subtotal_price / 100;
      const percentageToBeFreeShipping = 100 * subtotal / freeShippingThreshold;
      const itemCount = data.item_count;
      let isQualifiedFreeShipping = subtotal >= freeShippingThreshold;
      
      let progressBarLabel = "Add $" + (freeShippingThreshold - subtotal) + " more to get free shipping";
      
      if (isQualifiedFreeShipping) {
          progressBarLabel = "Congrats! You get free shipping ✨";
      }
      $('.cart-progress').css('display', 'block');
      $('.cart-progress-status').text(progressBarLabel);
      $('.cart-progress-bar__filled').css('width', `${percentageToBeFreeShipping}%`);

      // Update cart btn counter
      $('.btn-cart__counter').text(itemCount);
    });
}

function initializeGenericSwiper() {
  new Swiper(".generic-swiper", {
    slidesPerView: 2,
    spaceBetween: 12,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1240: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
    pagination: {
      el: ".generic-swiper-pagination",
      clickable: true,
    },
    on: {
      init: function () {
        const genericSwiper = document.getElementsByClassName("generic-swiper");

        for (swiper of genericSwiper) {
          swiper.style.display = "block";
        }
      },
    },
  });
}

initializeGenericSwiper();

// function addMiniProduct(id) {
//   console.log("id: ", id);
//   const addData = {
//     items: [
//       {
//         id: id,
//         quantity: 1,
//       },
//     ],
//   };

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(addData),
//   })
//     .then(async (res) => {
//       if (res.status === 200) {
//         window.location.reload();
//       }
//     })
//     .catch((err) => console.error(err));
// }

function addMiniProduct(id, type = null, e) {
  const button = $(e.currentTarget )
  
  button.addClass("loading")
  
  let setData;
  if (type !== null) {
    setData = {
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            _item_type: type
          }
        },
      ],
    };
  } else {
    setData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
    };
  }

  const addData = setData;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(addData),
  })
    .then((res) => {
      if (res.status === 200) {
        reloadMiniCartAjax();
      }
      button.removeClass("loading")
      button.addClass("success")
      setTimeout(()=>{
         button.removeClass("success")
      },2000)
    })
    .catch((err) => {
      console.error(err)
      button.removeClass("loading")
    });
}

// remove to cart -- pwp
function removePWP(id) {

  const removeData = {
    id: id,
    quantity: 0,
  };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(removeData),
  })
    .then((res) => {
      if (res.status === 200) {
        window.location.reload(true);
      }
    })
    .catch((err) => console.error(err));
}
// End - remove to cart -- pwp


// ... existing code ...

// Move to wishlist function
function moveToWishlist(element) {
  const productId = element.dataset.productId;
  const variantId = element.dataset.variantId;
  const productUrl = element.dataset.productUrl;
  const productTitle = element.dataset.productTitle;
  const variantTitle = element.dataset.variantTitle;
  const lineItemKey = element.dataset.lineItemKey;
  const lineIndex = element.dataset.lineIndex;

  // Show loading state
  element.textContent = 'Moving...';
  element.style.pointerEvents = 'none';

  // Add to wishlist using Swym
  if (window._swat && window._swat.addToWishlist) {
    window._swat.addToWishlist({
      epi: variantId,
      du: productUrl,
      dt: productTitle,
      empi: productId,
      pr: 0 // Price will be handled by Swym
    }).then(() => {
      // Remove from cart after successful wishlist addition
      removeFromCart(lineIndex, lineItemKey, element);
    }).catch((error) => {
      console.error('Error adding to wishlist:', error);
      // Reset button state on error
      element.textContent = 'Move to wishlist';
      element.style.pointerEvents = 'auto';
    });
  } else {
    console.error('Swym not available');
    element.textContent = 'Move to wishlist';
    element.style.pointerEvents = 'auto';
  }
}

// Remove item from cart
function removeFromCart(lineIndex, lineItemKey, wishlistButton) {
  const removeUrl = `/cart/change?line=${lineIndex}&quantity=0`;
  
  fetch(removeUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
  .then(response => {
    if (response.ok) {
      // Show success message
      wishlistButton.textContent = 'Moved!';
      wishlistButton.style.color = '#28a745';
      
      // Reload cart to update the UI
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      throw new Error('Failed to remove from cart');
    }
  })
  .catch(error => {
    console.error('Error removing from cart:', error);
    wishlistButton.textContent = 'Move to wishlist';
    wishlistButton.style.pointerEvents = 'auto';
  });
}

// Event listener for move to wishlist buttons
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('js-move-to-wishlist')) {
      e.preventDefault();
      moveToWishlist(e.target);
    }
  });
});

// Move callout popup
$(document).ready(function() {
  $("body").on('DOMSubtreeModified', ".cart-drawer", function() {
    if ($('.temp-modal').length) {
      $('.cloned-modal').remove();
      $('#dcd-modal').appendTo('body').attr('class', 'cloned-modal');
      $('.temp-modal').remove();
    }
  });
})